import { useCallback, useEffect, useState } from "react";
import {
  fetchMutationProcessingSettings,
  getCachedMutationProcessingSettings,
  hasMutationProcessingSettingsCache,
} from "../api/mutationProcessing.api";
import type { MutationProcessingResponse } from "../types/mutationProcessing.types";

export const useMutationProcessingSettings = (enabled: boolean) => {
  const [settings, setSettings] = useState<MutationProcessingResponse>(() => getCachedMutationProcessingSettings() ?? []);
  const [loading, setLoading] = useState(() => enabled && !hasMutationProcessingSettingsCache());
  const [error, setError] = useState<unknown>(null);

  const reload = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    setLoading(!hasMutationProcessingSettingsCache());
    setError(null);
    try {
      const data = await fetchMutationProcessingSettings();
      setSettings(data);
    } catch (loadError) {
      setError(loadError);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return {
    settings,
    setSettings,
    loading,
    error,
    reload,
  };
};
